var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagEn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#012169;}.cls-4,.cls-7{stroke:#fff;}.cls-4,.cls-6,.cls-7,.cls-8{stroke-miterlimit:80;}.cls-4,.cls-8{stroke-width:120px;}.cls-5{clip-path:url(#clip-path-2);}.cls-6,.cls-8{stroke:#c8102e;}.cls-6{stroke-width:80px;}.cls-7{stroke-width:200px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 1200,
    height: 600
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "600 300 1200 300 1200 600 600 600 0 600 0 300 0 0 600 0 1200 0 600 300"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flag-en") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0,0V600H1200V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M0,0,1200,600m0-600L0,600"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M0,0,1200,600m0-600L0,600"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M600,0V600M0,300H1200"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M600,0V600M0,300H1200"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEn);
export default __webpack_public_path__ + "static/media/flag-en.acc94dcf3d2bd1e3d77513d74079fdd9.svg";
export { ForwardRef as ReactComponent };